export default __webpack_public_path__ + "static/media/footer_background.59def341.jpg";